<div class="hard-form-control" [class.last]="last">
  <div class="equipment-selection-row">
    <div class="wrapper">
      <hard-form-dictionary-multiple
        [form]="form"
        [config]="innerConfig"
        [formControl]="form.get(config.name)"
        [last]="true"
      ></hard-form-dictionary-multiple>
      <ui-filter
        [fields]="filterFields"
        [templateColumns]="filterTemplateColumns"
        (searchEmit)="onFilterChange($event)"
      ></ui-filter>
  </div>

</div>
</div>
